jQuery(function($) {
	var $html = $('html').removeClass('no-js');

	$html.deepLinks();
	$('form input[id^="your-name_"]').attr('autocomplete', 'chrome-off');
	
	if(!$.supports.touch) {
		$('select[multiple]').multiselect();
	}

	// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE
	$html.on({
		change: function() {
			var $this = $(this);

			if($this.is(':checked')) {
				$this.parent().attr('data-open', 1);
			}
			else {
				setTimeout(function() {
					$this.parent().removeAttr('data-open');
				}, 1200);
			}
		}
	}, '.menu-item > input[type="checkbox"]');


	$html.on({
		change: function() {
			var $this = $(this);
			var myAudio = document.getElementById("myAudio");

			if($this.is(':checked')) {
				return myAudio.play();
			}
			else{
				return myAudio.pause();
			}
		}

	}, 'input[type="checkbox"]#music');

	$html.on({
		click: function() {
			var $links = $(this).parents('.article').find('.article__footer a'),
				href = $links.length == 1 ? $links.eq(0).attr('href') : false;
			if(!href) return false;
			if(href === window.location.href) return false;

			window.location.href = href;
		}
	}, 'lottie-player');
});